<template>
    <div class="order-panel">
        <el-tabs v-model="active" class="tabs-chenjk">
            <el-tab-pane label='全局监控' name='globalMonitoring'>
                <global-monitoring v-if="active === 'globalMonitoring'"></global-monitoring>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import globalMonitoring from './globalMonitoring';
export default {
    components: {
        globalMonitoring
    },
    data() {
        return {
            active: 'globalMonitoring'
        };
    }
};
</script>

<style lang="less">
</style>